import { RouteComponentProps, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { LoginDielEnergia } from './LoginDielEnergia';
import { useEffect, useState } from 'react';
import { getUserProfile } from '../../../helpers/userProfile';

interface LoginProps extends Pick<RouteComponentProps, 'history'> {
  setIsLogin: () => void;
  setIsLoading: () => void;
}

const dielEnergiaHost = 'energia.dielenergia.com';

export const Login: React.FC<LoginProps> = ({
  history,
  setIsLogin,
  setIsLoading,
}) => {
  const auth = useAuth();
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const toPage = queryParams.get('topage');
  const [profile] = useState(getUserProfile);
  function redirectRemoteControl() {
    if (profile.permissions.isPersonaII) return '/login-select';
    if (profile.permissions.isInstaller) return '/analise/unidades';
    const perUnitUnits = profile.permissions.PER_UNIT?.flatMap((x) => x.units) ?? [];
    if ((profile.permissions.PER_CLIENT?.length ?? 0) === 0 && perUnitUnits.length === 1) {
      return `/analise/unidades/${perUnitUnits[0]}`;
    }
    return '/nova-visao-geral';
  }

  useEffect(() => {
    if (window.location.href.includes(dielEnergiaHost)) {
      return;
    }

    if (isAuthenticated) {
      if (toPage) {
        history.push(toPage);
      } else {
        history.push(redirectRemoteControl());
      }
    } else {
      const link = `${window.location.origin}/login${toPage ? `?topage=${toPage}` : ''}`;
      auth.signinRedirect({
        redirect_uri: link,
      });
    }
  }, [isAuthenticated, history, toPage, auth]);

  if (window.location.href.includes(dielEnergiaHost)) {
    return (
      <LoginDielEnergia
        history={history}
        setIsLoading={setIsLoading}
        setIsLogin={setIsLogin}
      />
    );
  }

  return (
    <div>
      <h1>Redirecionando...</h1>
    </div>
  );
};
